<template>
  <div class="issueDescription w-100 d-flex flex-column">
    <h3 class="mt-5 mb-2">Please briefly describe the issue you are having</h3>
    <v-textarea
      auto-grow
      outlined
      v-model="issueDescription"
    />

    <h3 class="mt-5 mb-2 mx-auto">Upload any images related to this issue</h3>
    <v-row
      justify="space-around"
      no-gutters
    >
      <v-col
        cols="6"
        md="3"
      >
        <upload-image
          v-model="imageUrl"
          :imageUploadInfo="imageUploadInfo"
          :numberUpload="1"
        />
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        <upload-image
          v-model="imageUrl2"
          :imageUploadInfo="imageUploadInfo"
          :numberUpload="2"
        />
      </v-col>
      <v-col
        class="hidden-sm-and-down"
        cols="3"
      >
        <upload-image
          v-model="imageUrl3"
          :imageUploadInfo="imageUploadInfo"
          :numberUpload="3"
        />
      </v-col>
      <v-col
        class="hidden-sm-and-down"
        cols="3"
      >
        <upload-image
          v-model="imageUrl4"
          :imageUploadInfo="imageUploadInfo"
          :numberUpload="4"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UploadImage from '@/components/util/UploadImage.vue';

export default {
  name: 'IssueDescription',
  components: {
    UploadImage,
  },
  async mounted() {},
  data() {
    return {
      isLoading: false,
      issueDescription: '',
      imageUrl: '',
      imageUrl2: '',
      imageUrl3: '',
      imageUrl4: '',
      imageUploadInfo: {
        name: 'repairTickets',
        uploadUrl: 'repairTickets/s3Upload',
        bucketName: 'repairTickets',
      },
    };
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {},
  watch: {
    issueDescription() {
      this.$store.dispatch('repairTickets/setIssueDescription', this.issueDescription);
    },
  },
};
</script>

<style lang="scss"></style>
